import { useCallback, useEffect, useState } from 'react';
import {
    disableAdvertisingPostPromoEnabled,
    updateAdvertisingPostPromoEnabled,
} from '../../../utils/useAdvertisingPromoEnabled';
import { IconClose } from '../../icon/IconClose';
import { IconButton } from '../../input/IconButton';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { AdvertisingButton } from '../AdvertisingButton/AdvertisingButton';
import { AdvertisingPromoText } from '../AdvertisingPromoText/AdvertisingPromoText';
import { PromoWrapper } from './styles';
import { AdvertisingPromoButtonProps } from './types';

export const AdvertisingPromoButton: React.FC<AdvertisingPromoButtonProps> = (props) => {
    const [promo, setPromo] = useState(props.promo);

    const onClose = useCallback(() => {
        disableAdvertisingPostPromoEnabled();

        setPromo(false);
    }, []);

    useEffect(() => {
        if (promo) {
            updateAdvertisingPostPromoEnabled();
        }
    }, [promo]);

    if (!promo) {
        return <AdvertisingButton {...props} />;
    }

    return (
        <PromoWrapper {...props}>
            <Box background="var(--background-secondary)" borderRadius={2.5}>
                <AdvertisingButton borderRadius={2.5} />
            </Box>
            <AdvertisingPromoText maxWidth="250px" />
            <Flex flexGrow={1} alignItems="end" mr={1}>
                <IconButton size="xs" color="var(--color-invert)" onClick={onClose}>
                    <IconClose />
                </IconButton>
            </Flex>
        </PromoWrapper>
    );
};
